/**
 * Map pin for orgs whose globalConfig.baseEntity.mapIconType is "truck": the MUI
 * LocalShipping glyph (the Digital Twin header's truck-icon), drawn in the pin colour at the
 * same 0.8 opacity as the tinted bus and battery pins, 32px.
 */
export const TRUCK_MAP_ICON_TYPE = "truck";

const TRUCK_PATH = "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m13.5-9 1.96 2.5H17V9.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5";

export const isTruckMapIcon = (mapIconType) => String(mapIconType || "").toLowerCase() === TRUCK_MAP_ICON_TYPE;

/** A data URL for the truck pin in the given colour (#RRGGBB). */
export const truckMapPinUrl = (color) => {
    const svg = `<svg width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="${TRUCK_PATH}" fill="${color}" fill-opacity="0.8"/></svg>`;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
